import { Clock, Award, Heart, Users } from 'lucide-react';
import { useLanguage } from '@/context/LanguageContext';

const History = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-[#f6f6f8] pt-28 pb-20">
      {/* Hero */}
      <div
        className="relative h-[400px] mb-20 parallax"
        style={{
          backgroundImage: 'url("https://lh3.googleusercontent.com/aida-public/AB6AXuCWmfF8h0POfz1C5Lr1PCGinH2U48LQiGdPcEFMRTzI0YATRWreGJAEYChsW266PNh1XFVFXWwdK8A8G6kucCE_Oi1IBP86g8OFvX6slyw7YkGcl8TkTg3o7d7AhHfxOfCWou3fN455xa8-IKscUlfZ1t6EEmmknWg88gbPWwgvNovakJ3ksNWIpV75oh_-DwM4y4bB_XG2SiIjcv1w5T8__Le0XM-sROjN1D3ycoTxIdKagKlYOUSlJl_VpQI1J0M31T6ZENMLKTs")'
        }}
        data-testid="history-hero"
      >
        <div className="absolute inset-0 bg-[#101B2D]/60"></div>
        <div className="relative z-10 h-full flex items-center justify-center">
          <h1 className="text-5xl md:text-6xl font-extrabold text-white text-center animate-fade-in">
            {t('history.title')}
          </h1>
        </div>
      </div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Introduction */}
        <div className="mb-16 animate-slide-up" data-testid="history-intro">
          <p className="text-2xl text-gray-700 leading-relaxed font-serif italic text-center">
            {t('history.quote')}
          </p>
        </div>

        {/* Story */}
        <div className="space-y-12">
          <div className="bg-white rounded-2xl p-8 md:p-12 shadow-xl animate-slide-up" data-testid="history-section-1">
            <h2 className="text-3xl font-bold text-slate-900 mb-6 flex items-center gap-3">
              <Clock className="w-8 h-8 text-[#C5A059]" />
              {t('history.journeyTitle')}
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>{t('history.journeyText1')}</p>
              <p>{t('history.journeyText2')}</p>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-8 md:p-12 shadow-xl animate-slide-up" style={{ animationDelay: '0.1s' }} data-testid="history-section-2">
            <h2 className="text-3xl font-bold text-slate-900 mb-6 flex items-center gap-3">
              <Heart className="w-8 h-8 text-[#C5A059]" />
              {t('history.preservationTitle')}
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>{t('history.preservationText1')}</p>
              <p>{t('history.preservationText2')}</p>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-8 md:p-12 shadow-xl animate-slide-up" style={{ animationDelay: '0.2s' }} data-testid="history-section-3">
            <h2 className="text-3xl font-bold text-slate-900 mb-6 flex items-center gap-3">
              <Users className="w-8 h-8 text-[#C5A059]" />
              {t('history.familyTitle')}
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>{t('history.familyText1')}</p>
              <p>{t('history.familyText2')}</p>
            </div>
          </div>

          {/* Timeline */}
          <div className="bg-white rounded-2xl p-8 md:p-12 shadow-xl animate-slide-up" style={{ animationDelay: '0.3s' }} data-testid="history-timeline">
            <h2 className="text-3xl font-bold text-slate-900 mb-8 flex items-center gap-3">
              <Award className="w-8 h-8 text-[#C5A059]" />
              {t('history.timeline')}
            </h2>
            <div className="space-y-6">
              <div className="flex gap-6">
                <div className="flex-shrink-0 w-24 text-right">
                  <span className="text-2xl font-bold text-[#C5A059]">1747</span>
                </div>
                <div className="border-l-4 border-[#C5A059] pl-6 pb-6">
                  <p className="text-gray-700">{t('history.timeline1747')}</p>
                </div>
              </div>
              <div className="flex gap-6">
                <div className="flex-shrink-0 w-24 text-right">
                  <span className="text-2xl font-bold text-[#C5A059]">1980</span>
                </div>
                <div className="border-l-4 border-[#C5A059] pl-6 pb-6">
                  <p className="text-gray-700">{t('history.timeline1980')}</p>
                </div>
              </div>
              <div className="flex gap-6">
                <div className="flex-shrink-0 w-24 text-right">
                  <span className="text-2xl font-bold text-[#C5A059]">1988</span>
                </div>
                <div className="border-l-4 border-[#C5A059] pl-6 pb-6">
                  <p className="text-gray-700">{t('history.timeline1988')}</p>
                </div>
              </div>
              <div className="flex gap-6">
                <div className="flex-shrink-0 w-24 text-right">
                  <span className="text-2xl font-bold text-[#C5A059]">2012</span>
                </div>
                <div className="border-l-4 border-[#C5A059] pl-6 pb-6">
                  <p className="text-gray-700">{t('history.timeline2012')}</p>
                </div>
              </div>
              <div className="flex gap-6">
                <div className="flex-shrink-0 w-24 text-right">
                  <span className="text-2xl font-bold text-[#C5A059]">2016</span>
                </div>
                <div className="border-l-4 border-[#C5A059] pl-6">
                  <p className="text-gray-700">{t('history.timeline2016')}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default History;
